// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#3b5b94',
        secondary: '#050B1F',
        accent: '#204165',
      },
      dark: {
        primary: '#3b5b94',
        secondary: '#050B1F',
        accent: '#204165',
      },
    },
  },
})
